import { Box, HStack, Link } from "@chakra-ui/react";

const FloatingCircleDev = () => {
  if (process.env.NODE_ENV !== "development") {
    return null;
  }

  return (
    <HStack
      position="fixed"
      bottom="20px"
      right="20px"
      spacing={2}
      zIndex="tooltip"
    >
      <Link
        href="/dev/cle-palette"
        fontSize="xs"
        fontWeight={600}
        color="preview.primary"
        bg="white"
        px={3}
        py={2}
        borderRadius="md"
        boxShadow="md"
        borderWidth="1px"
        borderColor="blackAlpha.200"
      >
        CLE palette
      </Link>
      <Box
        width="50px"
        height="50px"
        borderRadius="50%"
        bg="blue.500"
        display="flex"
        alignItems="center"
        justifyContent="center"
        boxShadow="lg"
        cursor="pointer"
        _hover={{
          bg: "blue.600",
        }}
        onClick={() => {
          window.location.href = "/colors";
        }}
        title="Legacy colors page"
      />
    </HStack>
  );
};

export default FloatingCircleDev;
